export default __webpack_public_path__ + "static/media/behavior_reading_deficits_graph.28c0ae29.png";